import React from 'react';
import { motion } from 'framer-motion';

const PurchasePausedModal = ({ onClose }) => {
    return (
        <div className="relative w-full max-w-md mx-auto">
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
                <div className="flex items-center space-x-3">
                    <div className="flex items-center justify-center h-10 w-10 rounded-full bg-amber-500/20">
                        <i className="fas fa-shield-alt text-amber-400 text-lg"></i>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-100">Service Notice</h2>
                </div>
                <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-white transition-colors p-1 rounded-md hover:bg-dark-600"
                    aria-label="Close modal"
                >
                    <i className="fas fa-times text-lg"></i>
                </button>
            </div>

            {/* Content */}
            <motion.div
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                exit={{ opacity: 0, y: -20, transition: { duration: 0.15 } }} 
                transition={{ duration: 0.25, ease: "circOut" }}
                className="space-y-6"
            >
                {/* Main Message */}
                <div className="bg-gradient-to-br from-dark-600 to-dark-700 rounded-xl p-6 border border-dark-500">
                    <div className="text-center space-y-4">
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br from-amber-500/20 to-orange-500/20 mb-4">
                            <i className="fas fa-pause-circle text-amber-400 text-3xl"></i>
                        </div>
                        
                        <h3 className="text-lg font-semibold text-gray-100">
                            Plan Purchases Temporarily Unavailable
                        </h3>
                        
                        <div className="text-gray-300 space-y-3 leading-relaxed">
                            <p>
                                We've temporarily paused new plan purchases due to increased reports of Minecraft server breaches involving our service.
                            </p>
                            <p>
                                As a precautionary measure, we're implementing additional security protocols to protect our users and their servers.
                            </p>
                            <p className="text-sm text-gray-400">
                                Expected resumption: <span className="text-accent-green font-medium">within 48 hours</span>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Additional Info */}
                <div className="bg-dark-600/50 rounded-lg p-4 border border-dark-500/50">
                    <div className="flex items-start space-x-3">
                        <i className="fas fa-info-circle text-blue-400 text-sm mt-0.5 flex-shrink-0"></i>
                        <div className="text-sm text-gray-400 space-y-2">
                            <p>• Existing subscriptions remain fully active</p>
                            <p>• All current features and services are unaffected</p>
                            <p>• Enhanced security measures are being implemented</p>
                            <p>• We apologize for any inconvenience caused</p>
                        </div>
                    </div>
                </div>

                {/* Action */}
                <div className="pt-2">
                    <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={onClose}
                        className="w-full inline-flex justify-center items-center rounded-lg bg-gradient-to-r from-accent-purple to-accent-blue text-white font-medium px-6 py-3 hover:from-accent-purple/90 hover:to-accent-blue/90 focus:outline-none focus:ring-2 focus:ring-accent-purple/50 transition-all duration-200 shadow-lg"
                    >
                        <i className="fas fa-check mr-2"></i>
                        Understood
                    </motion.button>
                </div>
            </motion.div>
        </div>
    );
};

export default PurchasePausedModal;